import React from 'react';

export function useWindowDocumentTitle(title: string) {
  React.useEffect(() => {
    window.document.title = `${title} | AMS`;
  }, [title]);
}
